var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: _vm.wrapperClassesProp,
      on: {
        click: _vm.handleClick,
        dragover: function ($event) {
          $event.preventDefault()
          return _vm.handleDragOver.apply(null, arguments)
        },
        drop: function ($event) {
          $event.preventDefault()
          return _vm.handleDrop.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "form",
        {
          ref: "dropzone",
          staticClass: "dropzone",
          attrs: {
            action: _vm.uploadUrl,
            enctype: "multipart/form-data",
            method: "POST",
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showMessage,
                  expression: "showMessage",
                },
              ],
              staticClass: "dz-message",
            },
            [
              _c("i", {
                staticClass: "inticon-scan",
                class: { "mb-3": _vm.title },
              }),
              _vm._v(" "),
              _vm.title
                ? _c("h3", { staticClass: "mb-1" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.title) +
                        "\n            "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showHelpText
                ? _c("div", { staticClass: "dz-help-text" }, [
                    _c("p", { staticClass: "mb-0" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "drag file or click" +
                                (_vm.$root.translationKeySuffix
                                  ? _vm.$root.translationKeySuffix
                                  : "")
                            )
                          ) +
                          "\n                "
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _vm._t("default"),
          _vm._v(" "),
          _c("div", { staticClass: "fallback" }, [
            _c("input", {
              ref: "fallbackFileInput",
              attrs: {
                accept: _vm.acceptedMimeTypes,
                multiple: _vm.multipleUpload,
                name: _vm.fileInputName,
                type: "file",
              },
              on: { change: _vm.handleFileInputChanged },
            }),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.blockUpload,
            expression: "blockUpload",
          },
        ],
        staticClass: "block-dropzone",
        on: {
          click: function ($event) {
            $event.stopPropagation()
          },
        },
      }),
      _vm._v(" "),
      _vm.deactivated
        ? _c("div", { staticClass: "btn btn-secondary btn-deactivated" }, [
            _vm._v("\n        nicht aktiviert\n    "),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }